import { render, staticRenderFns } from "./Broker.vue?vue&type=template&id=c8031d6a"
import script from "./Broker.vue?vue&type=script&lang=js"
export * from "./Broker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports